import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js'
import { nanoid } from 'nanoid'
import { useState } from 'react'
import { API } from '../apis/API'
import { getErrorMessage, log } from '../helpers/utils'
import ErrorAlert from './Alerts/ErrorAlert'
import SuccessAlert from './Alerts/SuccessAlert'
import { Primary } from './Buttons/Primary'
import Loader from './Loader'

function AddCard({ customer, reloadComponent: reloadParent }) {
    const [enableCheckout, setEnableCheckout] = useState(false)
    const stripe = useStripe()
    const elements = useElements()
    const [error, setError] = useState(false)
    const [success, setSuccess] = useState(false)
    const [loading, setLoading] = useState(false)
    const [key, setKey] = useState(nanoid())

    const afterCardAdded = () => {
        setSuccess('Card Added Successfully.')
        reloadParent()
        setKey(nanoid())
        setTimeout(() => {
            setSuccess(false)
        }, 3000)
    }

    const handleAddCard = async (e) => {
        e.preventDefault()
        setLoading(true)
        setError(false)
        setSuccess(false)

        try {
            const { paymentMethod, error } = await stripe.createPaymentMethod({
                type: 'card',
                card: elements.getElement('card'),
            })

            if (error) throw Error(error.message)

            const { id: payment_method_id } = paymentMethod

            await API.attachCardToCustomer({
                payment_method_id,
                customer_id: customer.stripe_customer_id,
            })

            afterCardAdded()
        } catch (e) {
            log(e)
            setError(getErrorMessage(e))
        } finally {
            setLoading(false)
        }
    }

    return (
        <form onSubmit={handleAddCard}>
            <div className="bg-gray-50 p-3 space-y-3 border rounded">
                {loading && <Loader />}
                <h3 className="text-lg font-bold">Add New Card</h3>
                <CardElement
                    key={key}
                    onChange={(e) => {
                        setEnableCheckout(e.complete)
                    }}
                    options={{
                        classes: {
                            base: 'p-2 border-2 border-gray-300 border-olm focus:border-olm rounded-md',
                        },
                    }}></CardElement>
                <Primary disabled={!enableCheckout} type="submit">
                    Add New Card
                </Primary>
                {success && <SuccessAlert success={success} />}
                {error && <ErrorAlert error={error} />}
            </div>
        </form>
    )
}

export default AddCard
